module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAPCAYAAAAceBSiAAAAAXNSR0IArs4c6QAAAD9JREFUOBFj/L31f/2//wwNDHQGTIwMDUx0thPFulHLUYKDXpzRYKdXSKPYMxrsKMFBL85osNMrpFHsGdBgBwBlAwZMQ/V/HQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/extend bolus.png
// module id = 111
// module chunks = 7